import SalaryFigure from './SalaryFigure'
export default SalaryFigure
